import rules from './useSubscriptionsMessage.rules';

const processSubscription = (subscription, deps) => {
  const { type, status, substatus } = subscription;
  const property = `${status.toLowerCase()}/${substatus.toLowerCase()}`;
  const message = rules[type][property](subscription, deps);

  const processedSubscription = {
    ...subscription,
    message,
  };

  if (subscription && subscription.addonsList && subscription.addonsList.length > 0) {
    processedSubscription.addonsList = subscription.addonsList.map(addon => processSubscription(addon, deps));
  }

  return processedSubscription;
};

const useSubscriptionsMessage = (subscriptionList = [], deps = {}) => subscriptionList.map(subscription => processSubscription(subscription, deps));

export default useSubscriptionsMessage;
